import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import MetisMenu from "metismenujs";
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import SimpleBar from "simplebar-react";
import { getModules } from "../../helpers/backend";
import {
  TbUser,
  TbUsers,
  TbLayoutDashboard,
  TbTicket,
  TbMessageChatbot,
  TbFileUpload,
  TbFileTypePdf,
  TbSettings,
  TbDownload,
  TbShield,
  TbReportAnalytics,
} from "react-icons/tb";
import { FaImages } from "react-icons/fa";

const SidebarContent = (props) => {
  const ref = useRef();
  const user = JSON.parse(localStorage.getItem("user"));
  const groups = String(user.groups);

  const [activeModules, setActiveModules] = useState([]);
  const getDataModule = async () => {
    const response = await getModules();
    // Filtrar módulos activos
    const active = response.data.results.filter((module) => module.active);
    setActiveModules(active);
  };

  useEffect(() => {
    getDataModule();
  }, []);

  useEffect(() => {
    const initMenu = () => {
      new MetisMenu("#side-menu");
    };
    initMenu();
  }, []);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  // Función para verificar si un módulo está activo
  const isModuleActive = (moduleName) => {
    return activeModules.some((module) => module.name === moduleName);
  };

  // Función para verificar si el usuario es SuperAdmin
  const isSuperAdmin = () => {
    return groups.includes("SuperAdmin");
  };

  // Función para verificar si el usuario es Administrador
  const isAdministrador = () => {
    return groups.includes("Administrador");
  };

  // Función para verificar si el usuario es Supervisor
  const isSupervisor = () => {
    return groups.includes("Supervisor");
  };

  // Función para verificar si el usuario tiene permisos de SuperAdmin o Administrador
  const hasAdminPermissions = () => {
    return isSuperAdmin() || isAdministrador();
  };

  return (
    <React.Fragment>
      <SimpleBar style={{ height: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul
            className="metismenu list-unstyled"
            style={{ display: "grid", gap: "0" }}
            id="side-menu"
          >
            <li className="menu-title">{props.t("Menu")} </li>

            {/* Dashboard */}
            <li>
              <Link
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: ".7rem",
                }}
                to="/dashboard"
              >
                <TbLayoutDashboard
                  className="icon_menu"
                  size={22}
                  strokeWidth={2.3}
                />
                <span style={{ fontSize: ".9rem" }} key="t-dashboard">
                  Dashboard
                </span>
              </Link>
            </li>

            {/* Administración (Solo SuperAdmin) */}
            {isSuperAdmin() || isAdministrador() && isModuleActive("Users") ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="#"
                >
                  <TbUsers className="icon_menu" size={22} strokeWidth={2.8} />
                  <span style={{ fontSize: ".9rem" }} key="t-users">
                    Administración
                  </span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link style={{ fontSize: ".775rem" }} to="/users">
                      Usuarios
                    </Link>
                  </li>
                  {isSuperAdmin() ?
                    <li>
                      <Link style={{ fontSize: ".775rem" }} to="/modules">
                        Módulos
                      </Link>
                    </li>
                    : null}
                  <li>
                    <Link style={{ fontSize: ".775rem" }} to="/rol/add_rol">
                      Roles
                    </Link>
                  </li>
                  <li>
                    <Link style={{ fontSize: ".775rem" }} to="/users/qr-generator">
                      Generador QR
                    </Link>
                  </li>
                </ul>
              </li>
            ) : null}
            {/* Contactos (Todos los roles) */}
            {(hasAdminPermissions() || isSupervisor()) && isModuleActive("Contactos") ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="/contacts"
                >
                  <TbUser className="icon_menu" size={22} strokeWidth={2.9} />
                  <span style={{ fontSize: ".9rem" }} key="t-contacts">
                    Contactos
                  </span>
                </Link>
              </li>
            ) : null}
            {(hasAdminPermissions() || isSupervisor()) && isModuleActive("Carga") ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="/upLoad-dashboard"
                >
                  <TbFileUpload className="icon_menu" size={22} strokeWidth={2.9} />
                  <span style={{ fontSize: ".9rem" }} key="t-files">
                    Cargar Archivos
                  </span>
                </Link>
              </li>
            ) : null}
            {/* Cuidad Limpia (Todos los roles) */}
            {hasAdminPermissions() && isModuleActive("Chat") ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".75rem",
                  }}
                  to="/chat"
                >
                  <TbMessageChatbot className="icon_menu" size={22} strokeWidth={2.9} />
                  <span style={{ fontSize: ".9rem" }} key="t-canales">
                    Cuidad Limpia
                  </span>
                </Link>
              </li>
            ) : null}
            {/* Casos Todos los roles */}
            {isModuleActive("Casos") ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="/casos"
                >
                  <TbTicket className="icon_menu" size={22} strokeWidth={2.3} />
                  <span style={{ fontSize: ".9rem" }} key="t-casos">
                    OT
                  </span>
                </Link>
              </li>
            ) : null}

            {/* Parametrización (Solo Administradores y Supervisores) */}
            {(hasAdminPermissions() || isSupervisor()) ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="#"
                >
                  <TbSettings className="icon_menu" size={22} strokeWidth={2.3} />
                  <span style={{ fontSize: ".9rem" }} key="t-parametrizacion">
                    Parametrización
                  </span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link style={{ fontSize: ".775rem" }} to="/parametrizacion/tarifas">
                      Tarifas
                    </Link>
                  </li>
                  <li>
                    <Link style={{ fontSize: ".775rem" }} to="/parametrizacion/recipientes">
                      Recipientes
                    </Link>
                  </li>
                  <li>
                    <Link style={{ fontSize: ".775rem" }} to="/parametrizacion/actividades-economicas">
                      Actividades Económicas
                    </Link>
                  </li>
                </ul>
              </li>
            ) : null}

            {/* Galería de Imágenes (Solo Administradores y Supervisores) */}
            {(hasAdminPermissions() || isSupervisor()) ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="/galeria-imagenes"
                >
                  <FaImages className="icon_menu" size={22} strokeWidth={2.3} />
                  <span style={{ fontSize: ".9rem" }} key="t-galeria-imagenes">
                    Galería de Imágenes
                  </span>
                </Link>
              </li>
            ) : null}

            {/* Archivos de Actas (Solo Administradores y Supervisores) */}
            {(hasAdminPermissions() || isSupervisor()) ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="/archivos-actas"
                >
                  <TbFileTypePdf className="icon_menu" size={22} strokeWidth={2.3} />
                  <span style={{ fontSize: ".9rem" }} key="t-archivos-actas">
                    Archivos de Actas
                  </span>
                </Link>
              </li>
            ) : null}

            {/* Descargar Archivos (Solo Administradores y Supervisores) */}
            {(hasAdminPermissions() || isSupervisor()) ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="/descargar-archivos"
                >
                  <TbDownload className="icon_menu" size={22} strokeWidth={2.3} />
                  <span style={{ fontSize: ".9rem" }} key="t-descargar-archivos">
                    Descargar Archivos
                  </span>
                </Link>
              </li>
            ) : null}

            {(hasAdminPermissions()) ? (
              <li>
                <Link
                  className="has-arrow"
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="#"
                >
                  <TbReportAnalytics className="icon_menu" size={22} strokeWidth={2.3} />
                  <span style={{ fontSize: ".9rem" }} key="t-reportes">
                    Reportes
                  </span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link style={{ fontSize: ".775rem" }} to="/reportes-agentes">
                      Desempeño Agentes
                    </Link>
                  </li>
                  <li>
                    <Link style={{ fontSize: ".775rem" }} to="/reportes-actas">
                      Actas Enviadas
                    </Link>
                  </li>
                </ul>
              </li>
            ) : null}

            {(hasAdminPermissions() || isSupervisor()) ? (
              <li>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: ".7rem",
                  }}
                  to="/servicios-adicionales"
                >
                  <TbShield className="icon_menu" size={22} strokeWidth={2.3} />
                  <span style={{ fontSize: ".9rem" }} key="t-servicios-adicionales">
                    Servicios Adicionales
                  </span>
                </Link>
              </li>
            ) : null}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
};

export default withRouter(withTranslation()(SidebarContent));
